import { Layout as PageLayout } from 'modules/app/components/templates/generic-page-layout/Layout';

export const NoAccess = () => {
  const displayTitle = 'Access Denied';
  const displayMessage =
    'Sorry, you do not have permission to view this section of the page. Please contact your administrator for assistance.';

  return <PageLayout title={displayTitle} subtitle={displayMessage} />;
};
